import { component } from 'picoapp';
import srraf from 'srraf';
import { findOne } from '@/utils';

export default component((node, ctx) => {

  const image = findOne('img', node);
  image.style.willChange = 'transform';
  image.style.transform = 'translateY(calc(var(--ty) * 1px))';

  srraf(({y}, timestamp) => {
    // image.style.setProperty('--ty', y * 0.2);
  }).update();

});